import {Loader} from 'mc/lib';
import {storeFromArea} from 'mc/lib/utils';
import * as PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {Card, CardBlock, CardHeader} from 'reactstrap';
import {fetchZadostPlatbyIfNeeded, ZADOST_PLATBA_LIST_AREA} from '../../actions/zadostActions';
import PlatbaTable from '../platba/PlatbaTable';

const visibleColumnNames = [
    'cisloDokladu',
    'vs',
    'castkaPlatby',
    'castkaVyrovnani',
    'datumPlatby',
    'formaUhrady',
    'actions',
];

class ZadostPlatbyCard extends PureComponent {

    static propTypes = {
        zadost: PropTypes.object.isRequired
    };
    
    componentDidMount() {
        this.fetchData(true);
    }

    componentDidUpdate() {
        this.fetchData(false);
    }

    fetchData(force) {
        const {zadost, dispatch} = this.props;
        dispatch(fetchZadostPlatbyIfNeeded(zadost.pripadId, force));
    }

    renderBody() {
        const {platbaList} = this.props;
        if (platbaList.isFetching) {
            return <Loader/>;
        }
        if (!platbaList.fetched) {
            return null;
        }
        if (!platbaList.rows.length) {
            return <CardBlock>
                <i>Žádost nemá žádné platby.</i>
            </CardBlock>;
        }
        return <PlatbaTable rows={platbaList.rows}
                            visibleColumnNames={visibleColumnNames}
                            readOnly/>;
    }

    render() {
        return (
            <Card>
                <CardHeader>
                    <h2>Seznam plateb</h2>
                </CardHeader>
                {this.renderBody()}
            </Card>
        );
    }
}

const mapStateToProps = state => ({
    platbaList: storeFromArea(state, ZADOST_PLATBA_LIST_AREA),
});

export default connect(mapStateToProps)(ZadostPlatbyCard);
